import axios from 'axios'
const convertToChosen = (data) => {
  return data.map(d => {
    return {
      'value': d,
      'text': d
    }
  })
}
const getUniqueValues = (data, key) => {
  if (data === undefined) return
  return convertToChosen([...new Set(data.map(c => c[key]))].sort())
}

const getUniqueArrayValues = (data, key) => {
  if (data === undefined) return
  let values = [...new Map(data.map(c => c[key].filter((value, index, self) => self.indexOf(value))))]
  let options = []
  values.map(a => a.filter(b => {
    if (options.indexOf(b) < 0) {
      options.push(b)
    }
  }))
  options = options.filter(v => typeof v !== 'undefined')
  return convertToChosen(options.sort())
}
export default ({
  namespaced: true,
  getters: {
    filterValues: (state, getters) => {
      return state.filterValues
    },
    cases: (state, getters, rootState, rootGetters) => {
      return state.cases
    }
  },
  state: {
    cases: [],
    filter: {
      'suffix': ['CM', 'DM']
    },
    filterValues: {},

    baseUrl: process.env.VUE_APP_BASEURL
  },
  actions: {
    async getCases({
      commit,
      state
    }, filter) {
      return await axios.get(state.baseUrl + 'api/dataExplorer/export', {
        params: (typeof filter !== 'undefined' ? filter : state.filter)
      }).then((res) => {
        commit('DMU_DATA', res.data)
      })
    },
    async setFilter({
      commit
    }, filter) {
      return await commit('FILTER', filter)
    },
    async getFilterValues({
      commit,
      state
    }) {
      let caseTypes = axios.get(state.baseUrl + 'api/dataExplorer/options', {
        params: {
          suffix: ['CM', 'DM'],
          option: 'caseTypes'
        }
      }).then((res) => {
        return res.data
      })
      let regions = axios.get(state.baseUrl + 'api/dataExplorer/options', {
        params: {
          suffix: ['CM', 'DM'],
          option: 'regions'
        }
      }).then((res) => {
        return res.data
      })
      let allegations = axios.get(state.baseUrl + 'api/dataExplorer/options', {
        params: {
          suffix: ['CM', 'DM'],
          option: 'allegations'
        }
      }).then((res) => {
        return res.data
      })
      let divisions = axios.get(state.baseUrl + 'api/dataExplorer/options', {
        params: {
          suffix: ['CM', 'DM'],
          option: 'divisions'
        }
      }).then((res) => {
        return res.data
      })
      let findings = axios.get(state.baseUrl + 'api/dataExplorer/options', {
        params: {
          suffix: ['CM', 'DM'],
          option: 'findings'
        }
      }).then((res) => {
        return res.data
      })
      let penalties = axios.get(state.baseUrl + 'api/dataExplorer/options', {
        params: {
          suffix: ['CM', 'DM'],
          option: 'penalties'
        }
      }).then((res) => {
        return res.data
      })
      let reportingPeriods = axios.get(state.baseUrl + 'api/dataExplorer/options', {
        params: {
          suffix: ['CM', 'DM'],
          option: 'reportingPeriods'
        }
      }).then((res) => {
        return res.data
      })
      let overallRatings = axios.get(state.baseUrl + 'api/dataExplorer/options', {
        params: {
          suffix: ['CM', 'DM'],
          option: 'overallRatings'
        }
      }).then((res) => {
        return res.data
      })
      let publishedDates = axios.get(state.baseUrl + 'api/dataExplorer/options', {
        params: {
          suffix: ['CM', 'DM'],
          option: 'publishedDates'
        }
      }).then((res) => {
        return res.data
      })
      let caseNumbers = axios.get(state.baseUrl + 'api/dataExplorer/options', {
        params: {
          suffix: ['CM', 'DM'],
          option: 'caseNumbers'
        }
      }).then((res) => {
        return res.data
      })
      return await Promise.all([caseTypes, regions, allegations, divisions, findings, penalties, reportingPeriods, overallRatings, publishedDates, caseNumbers]).then((values) => {
        let filterValues = {
          caseTypes: values[0],
          regions: values[1],
          allegations: values[2],
          divisions: values[3],
          findings: values[4],
          penalties: values[5],
          reportingPeriods: values[6],
          overallRatings: values[7],
          publishedDates: values[8],
          caseNumbers: values[9]
        }
        commit('FILTER_VALUES', filterValues)
      })
    }
  },
  mutations: {
    DMU_DATA(state, data) {
      state.cases = data
    },
    FILTER(state, filter) {
      state.filter = filter
    },
    FILTER_VALUES(state, filterValues) {
      state.filterValues = filterValues
    }
  }
})
